<template lang="html">
  <div class="brand-bar">
    <div class="close-sidebar" v-if="showSidebarButton">
      <p4a-button :showIcon="true"
                  :onlyIconVisible="true"
                  :icon="'menu-collapse'"
                  :product="''"
                  :size="'large'"
                  :disable="false"
                  :text="'Delete'"
                  @click="collapseSidebar"
                  :class="sidebarVisible ? '' : 'closed'">
      </p4a-button>
    </div>
    <ul class="brand-bar__list">
      <li class="brand-bar__item">
        <a href="#" class="brand-bar__link product-portal" v-tooltip="{position: 'right', text: 'Portal'}">
          <p4a-icon :icon="'portal-logo'"></p4a-icon>
        </a>
      </li>
      <li class="brand-bar__item" v-if="product !== 'ds'">
        <a href="#" class="brand-bar__link product-docstream" v-tooltip="{position: 'right', text: 'Docstream'}">
          <p4a-icon :icon="'ds-logo'"></p4a-icon>
        </a>
      </li>
      <li class="brand-bar__item" v-if="product !== 'sns'">
        <a href="#" class="brand-bar__link product-snagstream" v-tooltip="{position: 'right', text: 'Snagstream'}">
          <p4a-icon :icon="'sns-logo'"></p4a-icon>
        </a>
      </li>
      <li class="brand-bar__item" v-if="product !== 'bms'">
        <a href="#" class="brand-bar__link product-bimstream" v-tooltip="{position: 'right', text: 'Bimstream'}">
          <p4a-icon :icon="'bms-logo'"></p4a-icon>
        </a>
      </li>
      <li class="brand-bar__item" v-if="product !== 'ls'">
        <a href="#" class="brand-bar__link product-leanstream" v-tooltip="{position: 'right', text: 'Leanstream'}">
          <p4a-icon :icon="'ls-logo'"></p4a-icon>
        </a>
      </li>
    </ul>

    <div class="toggle__toast"
         v-if="showNotificationButton"
         @click="turnOffNotifications"
         :class="showNotifications ? '' : 'toggle__toast--off'">
      <div class="toggle__toast__container">
        <p4a-icon :icon="'toast'" class="toggle__toast__icon"></p4a-icon>
        <span class="toggle__toast--badge"></span>
      </div>
    </div>

    <p4a-toast v-if="showNotifications" />

  </div>
</template>

<script>
  export default {

    name: 'BrandBar',
    props: {
      showSidebarButton: Boolean,
      product: String,
      showNotificationButton: Boolean
    },
    data () {
      return {
        sidebarVisible: true,
        showNotifications: false
      }
    },
    created () {
      this.showNotifications = JSON.parse(localStorage.getItem('showNotifications'))
    },
    methods: {
      collapseSidebar () {
        let value = this.sidebarVisible = !this.sidebarVisible
        this.$eventBus.$emit('sidebarVisible', value)
      },
      turnOffNotifications () {
        if (this.showNotifications) {
          this.showNotifications = false
          localStorage.setItem('showNotifications', false)
        } else {
          this.showNotifications = true
          localStorage.setItem('showNotifications', true)
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import '../styling/styling.scss';

  .brand-bar {
    width: rem(50);
    height: calc(100vh - #{rem(50)});
    float: left;
    position: relative;
    background: $medium-grey-font;

    .close-sidebar {

      .btn { color: $light-grey-font; }

      .closed {

        i {

          &:before {
            display: inline-block;
            transform: rotate(-180deg);
          }
        }
      }
    }

    &__link {
      height: rem(50);
      display: block;
      padding: rem(10);
      text-align: center;
      position: relative;
      font-size: rem(18);
      line-height: rem(30);
      text-decoration: none;
      color: $light-grey-font;
      background-color: transparent;

      &:hover, &:focus {
        color: $white;
        text-decoration: none;
      }

      &.product-docstream {

        &:hover { background-color: $docstream; }
      }

      &.product-snagstream {

        &:hover { background-color: $snagstream; }
      }

      &.product-portal {

        &:hover { background-color: $portal; }
      }

      &.product-leanstream {

        &:hover { background-color: $leanstream; }
      }

      &.product-bimstream {

        &:hover { background-color: $bimstream; }
      }

      &.product-assetstream {

        &:hover { background-color: $asstream; }
      }
    }
  }

  .toggle__toast {
    width: 100%;
    height: rem(50);
    bottom: 0;
    cursor: pointer;
    padding: rem(17);
    position: absolute;
    transition: all .3s ease;
    color: $light-grey-background;

    &__container { position: relative; }

    &__icon { transition: all .3s ease; }

    &--off {
      transition: all .3s ease;

      .toggle__toast__icon {
        opacity: 0.3;
        transition: all .3s ease;
      }

      .toggle__toast--badge { background-color: $error-red; }
    }

    &--badge {
      width: rem(8);
      height: rem(8);
      top: rem(-5);
      right: rem(-5);
      display: block;
      cursor: pointer;
      position: absolute;
      border-radius: 50%;
      background-color: $approved-green;
      transition: background-color .3s ease;
    }
  }
</style>



// WEBPACK FOOTER //
// node_modules/pro4all-ui/ui-kit/components/BrandBar.vue